import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EncodeB64Service {

  constructor() { }

  stringToB64(message: string): string {
    const encoder = new TextEncoder();
    const data = encoder.encode(message);

    return this.arrayBufferToBase64(data)
  }

  arrayBufferToBase64(arrayBuffer: ArrayBuffer): string {
    const uint8Array = new Uint8Array(arrayBuffer);

    const binaryString = uint8Array.reduce(function (data, byte) {
      return data + String.fromCharCode(byte);
    }, '');

    return btoa(binaryString);
  }

  async b64toBlob(b64Data: string, sliceSize: number = 512): Promise<Blob> {
    const byteCharacters = b64Data;
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const byteArray = new Uint8Array(atob(b64Data).split('').map(char => char.charCodeAt(0)));
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    return blob;
  }
}
